import Base from "./Base";
export default class Orders extends Base{
    constructor() {
        super()
        this.waRestoreBtn = document.getElementById("_waRestoreBtn");
        if (this.waRestoreBtn){
            this.loader()
        }
    }

    loader(){
        this.waRestoreBtn.onclick = async (event) =>{
            this.loaderMessage = this.JSAlert.loader("Restoring order. Please wait...")
            await this.restoreOrderHandler(event)
        }
    }

    async restoreOrderHandler(event){
        try {
            const handler = event.target
            const post_id = handler.getAttribute('data-post-id');
            const data = new FormData();

            data.append('action', 'archm_restore_post');
            data.append('nonce', this.nonce);
            data.append('post_id', post_id);

            const response = await fetch(this.ajaxUrl, {
                method: 'POST',
                body: data
            });

            if (!response.ok) return false
            const result = await response.json();

            if (result.success){
                this.loaderMessage.dismissIn(0)
                this.alertSuccess({
                    title: "Order restored successfully!",
                })
                setTimeout(()=>{location.reload()},200)
            }else{
                this.alertError({
                    title: 'Order restore error. please try again later!',
                })
            }
        }catch (e) {
            console.error(e)
        }
    }
}